import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

function useNuvemEnvioTranslations(keyPrefix?: string): TFunction {
  const { t } = useTranslation(Domain.NUVEM_ENVIO, { keyPrefix });

  return t;
}

export default useNuvemEnvioTranslations;
